import React from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { media } from "utils/style";

import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";
import StyledLink from "common-components/StyledLink";
import { history } from "../../../../Layout/Layout";

const FormerCustomerDeleteModal = ({ modalContent, closeModal, deletePersonal, currentIntent, serviceType, isOptOut, handleDeleteClick, ...props }) => (
  <Modal id="modalStyle" contentLabel="delete confirmation modal" visibleModal closeModal={closeModal} {...props}>
    
    
    <ModalDiv>
      <ModalTitle primitive= "h1">{modalContent.section_title}</ModalTitle>
    </ModalDiv>


    <ModalBody>{convertStringToElements(modalContent.section_description)} </ModalBody>
  <Container>
    <Div>
        <ButtonContainer>
          {
            deletePersonal && (
              <Button
                background={modalContent.buttons[0].type}
                onClick={() => handleDeleteClick()}
              >
                {modalContent.buttons[0].text}
              </Button>
            )
          }

          {
            !deletePersonal && (
              <Button
                background={modalContent.buttons[0].type}
                onClick={() => history.push({
                  pathname: "email-info",
                  state: {
                    confirmAuth: true, 
                    currentIntent: currentIntent, 
                    serviceType: serviceType, 
                    flow: "deletion", 
                    isOptOutChoice: isOptOut
                  }
                })
                }
              >
               {modalContent.buttons[0].text}
              </Button> 
              // <StyledLink
              //   background={modalContent.buttons[0].type}
              //   to={{ pathname: "email-info", state: { confirmAuth: true, currentIntent: currentIntent, serviceType: serviceType, flow: "deletion", isOptOutChoice: isOptOut } }}
              // >
              //   {modalContent.buttons[0].text}
              // </StyledLink>
            )
          }
          <Button data-testId="deleteModal_cancelBtn" background={modalContent.buttons[1].type} onClick={closeModal}>
            {modalContent.buttons[1].text}
          </Button>
        </ButtonContainer>
      </Div>
    </Container>
  </Modal>
);

export default FormerCustomerDeleteModal;

const Container = styled.div`
  max-width: 420px;

  ${media.mobile`
    padding-right: 0;
  `}
`;

const ModalDiv = styled.div`

  ${media.mobile`
    margin-top: 25px;
  `}
`;

const Div = styled.div`
 margin-top: 32px;
 font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
 font-weight: 400;
 font-size: 16px;
 line-height: 20px;

  p {
    padding: 10px 0;
  }

  ${media.mobile`
  @media only screen and (max-width: 480px) {
    .buttonContainer {
      position:absolute;
      bottom:10px;
      right:0px;
      left:0px;
      margin:20px
    }
  }
 
`}
`;
const ButtonContainer = styled.div`
  margin-top: 32px;
  display: flex;
  ${media.mobile`
   flex-direction: column;
  `}
`;


const H2 = styled.h2`
font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
font-style: normal;
font-weight: 300;
font-size: 32px;
${media.mobile`
margin-right: 20px;
font-weight: 400;
font-size: 24px;
`}
`;
